<div *ngIf="!readOnlyMode" class="radio-btn-container">
  <input
    class="radio-button"
    type="radio"
    name="{{name}}"
    [id]="id"
    [formControl]="inputFormControl"
    value="{{labelName}}"
    [checked]="inputFormControl && labelName === inputFormControl.value"
  />
  <label
    class="radio-button-text"
    [for]="id"
    *ngIf="!readOnlyMode"
    >
    {{ labelName }}
  </label>
</div>
<label
  *ngIf="readOnlyMode && labelName === inputFormControl.value"
  >
  {{ labelName }}
</label>
